import React, {Component} from 'react';

const LoadingProduct = () =>{
  return(
    <div className="product loading">
      <div className="product-image"></div>
      <div className="product-text"></div>
      <div className="product-text"></div>
      <div className="product-text"></div>
      <div className="product-button"></div>
    </div>
  )
};

export default LoadingProduct;
